import React, { useState, useEffect } from "react";
import httpClient from "../../utils/httpClients";
import { useNavigate } from "react-router-dom";

function ArtistSubscription() {
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [isYearly, setIsYearly] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeSubscription, setActiveSubscription] = useState(null);
  const navigate = useNavigate();

  const fetchSubscriptionPlan = async (billingCycle) => {
    try {
      setLoading(true);
      setError(null);
      const res = await httpClient.get(
        `/user/user-subscription/all-plans/${billingCycle}`,
      );
      if (
        res.data &&
        res.data.success &&
        res.data.data &&
        res.data.data.plans
      ) {
        setSubscriptionPlans(res.data.data.plans);
      } else {
        setError("Failed to fetch subscription plans");
      }
    } catch (err) {
      setError("Error fetching subscription plans. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchActiveSubscription = async () => {
    try {
      const res = await httpClient.get("/user/user-subscription/active");
      if (res.data && res.data.success) {
        const activeSubscription = res.data.data.activeSubscriptions[0];
        setActiveSubscription(activeSubscription);
      }
    } catch (error) {
      console.error("Error fetching active subscription:", error);
    }
  };
  useEffect(() => {
    fetchSubscriptionPlan("monthly");
    fetchActiveSubscription();
    window.scrollTo(0, 0);
  }, []);

  console.log("activeSubscription", activeSubscription);
  const handleChoosePlan = (plan) => {
    if (!plan || !plan._id) return;
    sessionStorage.setItem("checkoutPlan", JSON.stringify(plan));
    navigate(`/artist/subscription/checkout/${plan._id}`, {
      state: { plan },
      name: "subscription",
    });
  };

  const handleBillingCycleChange = (event) => {
    const yearly = event.target.checked;
    setIsYearly(yearly);
    const billingCycle = yearly ? "yearly" : "monthly";
    fetchSubscriptionPlan(billingCycle);
  };

  const getYearlyPrice = (monthlyPrice) => {
    return typeof monthlyPrice === "number" ? monthlyPrice * 12 : 0;
  };

  const renderPlanCard = (plan) => {
    if (!plan) return null;
    const displayPrice = isYearly ? getYearlyPrice(plan.price) : plan.price;
    const billingPeriod = isYearly ? "year" : "month";

    return (
      <div key={plan._id} className="col-md-6 mb-4">
        <div className="card pricing-box-2 mb-lg-0">
          <div className="card-body">
            <h3>{plan.name}</h3>
            <h2 className="my-4 pricingtable__highlight">
              <b>
                {plan.price === 0
                  ? `Free / ${billingPeriod}`
                  : `$${displayPrice} / ${billingPeriod}`}
              </b>
            </h2>
            <ul className="p-0 mb-0 list-unstyled">
              {Array.isArray(plan.features) &&
                plan.features.map((feature, index) => (
                  <li key={index}>
                    <p className="mb-4">
                      <svg
                        width={8}
                        className="me-2"
                        viewBox="0 0 8 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx={4} cy={4} r={4} fill="currentColor" />
                      </svg>
                      {feature
                        .replace(/_/g, " ")
                        .replace(/\b\w/g, (char) => char.toUpperCase())}
                    </p>
                  </li>
                ))}
            </ul>
            {activeSubscription &&
              activeSubscription?.planId?.planKey !== plan?.planKey &&
              typeof plan.name === "string" &&
              plan.name.includes("Pro") && (
                <div className="type-2">Recommended</div>
              )}
            {activeSubscription?.planId?.planKey === plan?.planKey ? (
              <div className="current-plan">Current Plan</div>
            ) : (
              <button
                type="button"
                className="btn btn-primary border"
                onClick={() => handleChoosePlan(plan)}
              >
                Choose
              </button>
            )}
            {/* <button
              type="button"
              className="btn btn-primary border"
              onClick={() => handleChoosePlan(plan)}
            >
              Choose
            </button> */}
          </div>
        </div>
      </div>
    );
  };

  // if (loading) {
  //   return (
  //     <div className="content-inner pb-0 container-fluid" id="page_layout">
  //       <div className="row mb-5">
  //         <div className="col-lg-12">
  //           <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
  //             <div className="spinner-border text-primary" role="status">
  //               <span className="visually-hidden">Loading...</span>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  if (error) {
    return (
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div className="row mb-5">
          <div className="col-lg-12">
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      <div className="row mb-5">
        <div className="col-lg-12">
          <div className="card-header">
            <div className="header-title">
              <h2 className="card-title text-capitalize mb-3">Choose Plan</h2>
            </div>
            <div className="card">
              <div className="justify-content-center justify-content-sm-between d-flex card-header border-bottom">
                <div className="d-flex justify-content-center align-items-center mt-1 mt-sm-0 col-sm-auto">
                  <label className="me-2 form-check-label">Monthly</label>
                  <div className="form-check form-switch">
                    <input
                      type="checkbox"
                      id="contcheckbox"
                      className="form-check-input"
                      checked={isYearly}
                      onChange={handleBillingCycleChange}
                    />
                    <label
                      htmlFor="contcheckbox"
                      className="ms-2 align-top form-check-label"
                    >
                      Yearly
                    </label>
                  </div>
                </div>
              </div>
              {loading ? (
                <>
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "200px" }}
                  >
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                </>
              ) : (
                <div className="card-body">
                  <div className="row">
                    {subscriptionPlans && subscriptionPlans.length > 0 ? (
                      subscriptionPlans.map(renderPlanCard)
                    ) : (
                      <div className="col-12 text-center">
                        <p>No subscription plans found.</p>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ArtistSubscription;
